import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Image, Icon } from 'semantic-ui-react';
import GeneralHelper from '../helpers/general';
import LocalStorageHelper from '../helpers/LocalStorage';
import './index.css';
import AuthHelper from '../helpers/auth';

export class BasicLayout extends Component {
	render() {
		// const { location } = this.props.children.props;
		// const showLogoutButton = location.pathname.indexOf('/unauthorized') === 0;
		return (
			<div>
				<div className="navigation-layout-header">
					<div className="navigation-layout-header-left">
						<Image
							className="navigation-layout-header-left-logo"
							src={`${GeneralHelper.getImageBasePath()}/images/logo-white.svg`}
						/>
						<div className="navigation-layout-header-left-separator" />
						<div className="navigation-layout-header-left-product">Residential Life</div>
					</div>
					{
						AuthHelper.isAuthenticated() &&
						<div className="navigation-layout-header-logout">
							<span>You are logged in as <u><b>{LocalStorageHelper.getUsername()}</b></u></span>
							<span style={{marginLeft: 10, marginRight: 10}}>|</span>
							<Link
								to="/logout"
								style={{color: 'white'}}
							>
								<Icon
									name="sign out"
									style={{ paddingRight: 4 }}
								/>
							Logout
							</Link>
						</div>
					}
				</div>
				<div className={"main-section"}>
					{this.props.children}
				</div>
			</div>
		);
	}
}

export default BasicLayout;
